<template>
    <div
        class="code-input"
        :class="{ disabled }"
        v-tippy="{ followCursor: true, placement: 'bottom-end' }"
        :content="$t('message.toActivatePlanNeedOthers')"
    >
        <a-input v-model="cloneValue" :disabled="disabled" />
        <div v-if="!disabled" class="confirm-code" @click="confirm">
            <div class="material-icons">check</div>
        </div>
    </div>
</template>

<script>
import log2 from "../../utils/log2";

const log = log2("Card");
export default {
    name: "Card",
    props: {
        value: {
            type: String,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            cloneValue: null,
        };
    },
    mounted() {
        this.cloneValue = this.$_.cloneDeep(this.value);
    },
    methods: {
        confirm() {
            if (this.disabled) return;
            this.$emit("input", this.cloneValue);
            this.$emit("confirm", this.cloneValue);
        },
    },
    watch: {
        value() {
            if (this.value !== this.cloneValue) {
                this.cloneValue = this.value;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.code-input {
    position: relative;
    display: flex;
    align-items: center;
    margin-top: 10px;

    &.disabled {
        cursor: not-allowed;

        &::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgb(255 255 255 / 36%);
            z-index: 1;
        }
    }

    .ant-input:hover,
    .ant-input:focus {
        border-color: #ec4b1d;
        box-shadow: none;
    }

    .confirm-code {
        background: #ec4b1d;
        line-height: 0;
        position: absolute;
        right: 4px;
        cursor: pointer;
        padding: 2px;

        .material-icons {
            color: white;
            font-size: 18px;
        }
    }
}
</style>
